/**
 * Circle URL slug utilities.
 * Converts circle names to SEO-friendly URL slugs.
 */

export function slugify(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function circleUrl(slug: string, sub?: string): string {
  const base = `/circles/${slug}`;
  return sub ? `${base}/${sub}` : base;
}
